import { Component, OnInit } from '@angular/core';
import { BackOffServiceService } from '../services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserData } from '../model/UserData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbdModalContent } from '../alert-component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-login-component',
  templateUrl: './login-component.component.html',
  styleUrls: ['./login-component.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;

  successMessage: string;
  failedMessage: string;
  isDoc = false;
  isCoach = false;
  isLoggin = false;
  lifestyleDone = false;
  qualify = false;
  isEnrolled = false;

  constructor(
    private _bkoffService: BackOffServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private cookie: CookieService,
  ) {

  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({

      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(7)]],

    });
  }

  get fmBuilder() { return this.loginForm.controls; }


  getFormControl(name: any) {
    return this.loginForm.get(name);
  }

  reset() {
    this.loginForm.reset({ PersonalData: new UserData() });
  }

  logInSubmit() {


    // Make sure to create a deep copy of the form-model
    const result: UserData = Object.assign({}, this.loginForm.value);
    const fromResult = Object.assign({}, result);


    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }




    const signUpData = this.loginForm;

    const userInfo = new UserData();
    userInfo.Email = signUpData.get(['email']).value;
    userInfo.password = signUpData.get(['password']).value;


    this._bkoffService.Login(userInfo).then((user) => {
      this.successMessage = 'successfully logged in !';
      console.log('successfully logged in ');
      this.cookie.set('isFinishedLogin', 'true');
      this.cookie.set('sessionToken', user.getSessionToken());
      this.cookie.set('userObjectId', user.id);
      this._bkoffService.getisDone().then((res) => {
        this.isDoc = true;
        this.isCoach = true;
        this.qualify = false;
        this.isEnrolled = true;
        if (this.isDoc === res[1]) {
          this.cookie.set('patientId', 'none');
          this.router.navigateByUrl('/doccard');
        } else if (this.isCoach === res[4]) {
          this.router.navigateByUrl('/coachclasses');
        } else if (this.isEnrolled === res[6]) {
          this.router.navigateByUrl('/logs');
        } else {
          this.cookie.deleteAll();
          localStorage.clear();
          this.router.navigateByUrl('/login');
          this.failedMessage = 'Error logging in, User is not enrolled in the program';
          console.log(this.failedMessage);
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.name = 'Login Error: as of now you are not enrolled in our program';
        }
      });
    },
      () => {
        this.failedMessage = 'Error logging in';
        console.log(this.failedMessage);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.name = 'Login Error: check for valid email and password';
      });
    // .catch(() => {
    //   this.failedMessage = "Error logging in"
    //   console.log(this.failedMessage)
    //   const modalRef = this.modalService.open(NgbdModalContent);
    //   modalRef.componentInstance.name = 'Login Error: check for valid email and password';

    // })
  }

  forgotPass() {
    const result = this._bkoffService.resetPassword(this.loginForm.get(['email']).value);
    if (result === 'SUCCESS') {
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'Please check your email to reset your password';
      modalRef.componentInstance.title = 'Email Reset:';

    }

  }

  toggleSignup() {
    console.log('in toggle signup');
    this.isLoggin = !this.isLoggin;
  }

}
